import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import AppNavbar from "./AppNavbar"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { InputGroup } from 'react-bootstrap';
import DatePicker from 'react-datepicker';

const EXPORT_REPORT_API = 'https://hospital.rozeetechnist.com/hospital-api/exportReport.php';

const Home = () => {
    const navigate = useNavigate();
    const [list, setList] = useState(null);
    const [totalDonation, setTotalDonation] = useState(null);
    const [totalCredited, setTotalCredited] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [pdfDownloading, setPdfDownloading] = useState(false);

    useEffect(() => {
        if (localStorage.getItem('login')) {
            // navigate('/list');
        } else {
            navigate('/login');
        }
    }, [navigate]);

    const getLoggedUserId = () => {
        const loginData = localStorage.getItem('login');
        if (loginData) {
            try {
                const user = JSON.parse(loginData);
                return user.id;
            } catch (error) {
                console.error('Error parsing login data:', error);
            }
        }
        return null;
    };

    const getUserRole = () => {
        const loginData = localStorage.getItem('login');
        if (loginData) {
            try {
                const user = JSON.parse(loginData);
                return user.role || null;
            } catch (error) {
                console.error('Error parsing login data:', error);
            }
        }
        return null;
    };

    useEffect(() => {
        // Only fetch data for admin users
        if (getUserRole() === 'admin') {
            getData();
        }
    }, [startDate, endDate]);

    const downloadPdfFromBackend = () => {
        setPdfDownloading(true);
        const payload = {
            search: '',
            city: '',
            filter: 'dashboard-report',
            start_date: formatDateToYYYYMMDD(startDate) || '',
            end_date: formatDateToYYYYMMDD(endDate) || '',
            output: 'pdf'
        };
        fetch(EXPORT_REPORT_API, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        })
            .then((res) => res.json())
            .then((result) => {
                setPdfDownloading(false);
                if (result.status && result.url) {
                    window.open(result.url, '_blank');
                } else {
                    console.error(result.message || 'PDF generation failed');
                }
            })
            .catch((err) => {
                setPdfDownloading(false);
                console.error(err);
            });
    };

    const getData = () => {
        const loggedUserId = getLoggedUserId();

        fetch(`https://hospital.rozeetechnist.com/hospital-api/dashboard.php`, {
            method: "Post",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                start_date: formatDateToYYYYMMDD(startDate),
                end_date: formatDateToYYYYMMDD(endDate),
                user_id: loggedUserId
            })
        })
            .then((response) => response.json())
            .then((result) => {
                setList(result.data);
                setTotalDonation(result.total_donation);
                setTotalCredited(result.total_credited_amount);
            })
            .catch((error) => console.error('Error fetching data:', error));

    };

    const formatDateToYYYYMMDD = (date) => {
        if (!date) return null;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleStartDateChange = (date) => {
        setStartDate(date);
    };

    const handleEndDateChange = (date) => {
        setEndDate(date);
    };
    const userRole = getUserRole();
    const isAdmin = userRole === 'admin';
    const isUser = userRole === 'user';

    return (
        <div>
            <AppNavbar />
            <section className="wrapper">
                <div className="container">
                    <div className="row top-page-bar">
                        <div className="col-md-8">
                            <div className="main-title">
                                <h1>Dashboard</h1>
                            </div>
                        </div>
                        {isAdmin && (
                            <div className="col-md-12">
                                <div className="search-area mb-2">
                                    <InputGroup>
                                        <DatePicker
                                            selected={startDate}
                                            onChange={handleStartDateChange}
                                            dateFormat="dd-MM-yyyy"
                                            placeholderText='Start Date'
                                            className="form-control"
                                        />
                                        <InputGroup.Text></InputGroup.Text>
                                        <DatePicker
                                            selected={endDate}
                                            onChange={handleEndDateChange}
                                            dateFormat="dd-MM-yyyy"
                                            placeholderText='End Date'
                                            className="form-control"
                                        />
                                        <div className="buttons filters">
                                            <span
                                                role="button"
                                                className={pdfDownloading ? 'disabled' : ''}
                                                onClick={() => !pdfDownloading && downloadPdfFromBackend()}
                                                title="Download PDF"
                                                style={{ cursor: pdfDownloading ? 'wait' : 'pointer' }}
                                            >
                                                {pdfDownloading ? '...' : <FontAwesomeIcon icon={faFilePdf} />}
                                            </span>
                                        </div>
                                    </InputGroup>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <main className="container">
                    {isUser ? (
                        // User role: Show only two buttons
                        <div className='row justify-content-center'>
                            <div className='col-12 col-md-8 col-lg-6' style={{ paddingTop: '50px', paddingBottom: '50px' }}>
                                <div className='d-flex flex-column gap-3'>
                                    <Link
                                        to="/donation-create"
                                        className="btn btn-primary btn-lg w-100"
                                        style={{
                                            padding: '20px 30px',
                                            fontSize: '18px',
                                            borderRadius: '8px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        Create Donation
                                    </Link>
                                    <Link
                                        to="/donation-list"
                                        className="btn btn-success btn-lg w-100"
                                        style={{
                                            padding: '20px 30px',
                                            fontSize: '18px',
                                            borderRadius: '8px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        Donation List
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ) : (
                        // Admin role: Show statistics
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='col-md-2 statetics-box total-box'>
                                    <span className="city">ટોટલ</span>
                                    <span className="donation">લખાવેલ : <span>{totalDonation}</span></span>
                                    <span className="credited">જમા : <span>{totalCredited}</span></span>
                                </div>

                                {list && list.map((item, index) => (
                                    <div key={index} className='col-md-2 statetics-box'>
                                        <span className="city">{item.city_name}</span>
                                        <span className="donation">લખાવેલ : <span>{item.total_donation_amount}</span></span>
                                        <span className="credited">જમા : <span>{item.total_credited_amount}</span></span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </main>
            </section>
        </div>
    );
};

export default Home;